<template>
  <div class="glass-frosted rounded-8xl w-83 h-67.5 p-4 min-h-fit">
    <div class="w-75 h-47.5 rounded-4xl bg-white overflow-hidden">
      <img :src="src" class="w-full h-full object-cover" />
    </div>

    <p class="text-black-white text-s-medium mt-2 text-center">
      {{ $t('keys.videoCarousel.instruction') }}
    </p>
  </div>
</template>

<script setup lang="ts">
  const props = defineProps<{
    src: string
  }>()
</script>

<style scoped></style>
